// 辅助方法

// 数组值比较器
function compare (propertyName) {
  return function (object1, object2) {
    var value1 = object1[propertyName]
    var value2 = object2[propertyName]
    if (value2 < value1) {
      return 1
    } else if (value2 > value1) {
      return -1
    } else {
      return 0
    }
  }
}

export default {
  install (Vue, options) {
    /**
     * 常用输入校验
     * 1 真实姓名
     * 2 手机号码
     * 3 中国身份证
     * 4 邮箱地址
     * 5 车牌号码
     */
    Vue.prototype.ver_input = (type, str) => {
      // 真实姓名
      if (type === 1) {
        if (str.length > 1 && !/[^\u4e00-\u9fa5]/.test(str)) {
          return true
        } else {
          return false
        }
      }

      // 手机号码
      if (type === 2) {
        if (/^[1][3,4,5,7,8][0-9]{9}$/.test(str)) {
          return true
        } else {
          return false
        }
      }

      // 中国身份证
      if (type === 3) {
        let arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        let arrValid = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
        if (/^\d{17}\d|x$/i.test(str)) {
          var sum = 0
          var idx
          for (var i = 0; i < str.length - 1; i++) {
            // 对前17位数字与权值乘积求和
            sum += parseInt(str.substr(i, 1), 10) * arrExp[i]
          }
          idx = sum % 11
          // 检验第18为是否与校验码相等
          if (!(arrValid[idx].toString() === str.substr(17, 1).toUpperCase())) {
            return false
          }
        } else {
          return false
        }
        return true
      }

      // 邮箱地址
      if (type === 4) {
        let reg = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/
        if (reg.test(str)) {
          return true
        } else {
          return false
        }
      }

      // 车牌号码
      if (type === 5) {
        let creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/
        let xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/
        if (str.length === 7) {
          return creg.test(str)
        } else if (str.length === 8) {
          return xreg.test(str)
        } else {
          return false
        }
      }
    }

    /**
     * 获取站点数据
     * ifPrice 是否查询油价
     */
    Vue.prototype.get_site_data = (that, ifPrice, successfn) => {
      // 获取站点数据
      that.ax(that, 'sel_site', {set_price: ifPrice}, (res) => {
        if (res.err_num === 0) {
          // 获取当前坐标
          global.wx.getLocation({
            type: 'gcj02',
            success: (wxres) => {
              // 计算距离
              res.data.forEach(val => {
                if (val.lat !== null) {
                  let radLat1 = wxres.latitude * Math.PI / 180.0
                  let radLat2 = val.lat * Math.PI / 180.0
                  let a = radLat1 - radLat2
                  let b = wxres.longitude * Math.PI / 180.0 - val.lng * Math.PI / 180.0
                  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
                  s = s * 6378.137
                  val.km = Math.round(s * 100) / 100
                }
              })

              // 计算排序
              successfn(res.data.sort(compare('km')))
            },
            fail: () => {
              that.$notify({ type: 'warning', message: '获取定位失败,请手动选择站点' })
              successfn(res.data)
            }
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/helper.js